import { useEffect, useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link, useLocation } from 'react-router-dom'
import { useFormik } from 'formik'
import { resetPassword, validateResetPasswordLink } from '../core/_requests'
import { KTIcon, toAbsoluteUrl } from '../../../../_metronic/helpers'

const initialValues = {
    firstPassword: '',
    password: '',

}

const resetPasswordSchema = Yup.object().shape({
    firstPassword: Yup.string().required('Contraseña es requerida'),
    password: Yup.string().required('Confirmación de Contraseña es requerida'),
})

export function ResetPassword() {
    const [loading, setLoading] = useState(false)
    const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
    const [hasValidLink, setHasValidLink] = useState<boolean | undefined>(undefined)
    const [showFirstPassword, setShowFirstPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [passwordMatch, setPasswordMatch] = useState<boolean | undefined>(undefined);
    const [showLinkLogin, setShowLinkLogin] = useState(false);
    const theme = localStorage.getItem('kt_theme_mode_value')


    const toggleFirstPasswordVisibility = () => {
        setShowFirstPassword(!showFirstPassword);
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const formik = useFormik({
        initialValues,
        validationSchema: resetPasswordSchema,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            setLoading(true)
            setHasErrors(undefined)
            const searchParams = new URLSearchParams(location.search);
            const usuarioId = searchParams.get('u');
            setTimeout(() => {
                resetPassword(usuarioId!, values.password)
                    .then(({ data: { result } }) => {
                        setHasErrors(false)
                        setLoading(false)
                        setShowLinkLogin(true);
                    })
                    .catch(() => {
                        setHasErrors(true)
                        setLoading(false)
                        setSubmitting(false)
                        setStatus('The login detail is incorrect')
                    })
            }, 1000)
        },
    })

    const location = useLocation();

    useEffect(() => {
        const fetchData = async () => {
            const searchParams = new URLSearchParams(location.search)
            const usuarioId = searchParams.get('u')
            const correo = searchParams.get('p')

            if (usuarioId && correo) {
                const isValid = await validateResetPasswordLink(usuarioId, correo);
                setHasValidLink(isValid);
            } else {
                setHasValidLink(false);
            }
        }

        fetchData()
    }, [location.search]);

    useEffect(() => {
        // Verificar si ambos campos tienen valores y compararlos
        if (formik.values.firstPassword && formik.values.password) {
            setPasswordMatch(formik.values.firstPassword === formik.values.password);
        }
    }, [formik.values.firstPassword, formik.values.password]);

    return (
        <form
            className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
            noValidate
            id='kt_login_password_reset_form'
            onSubmit={formik.handleSubmit}
        >
            <div className='text-center mb-11'>
                {theme === 'light' ?
                    <img alt='Logo' src={toAbsoluteUrl('/media/logos/GC-Track_light_company.png')} className='h-90px' /> :
                    <img alt='Logo' src={toAbsoluteUrl('/media/logos/GC-Track_dark_company.png')} className='h-90px' />
                }
            </div>
            {(hasValidLink) ? (
                <>

                    <div className='text-center mb-5'>
                        <h1 className='text-dark fw-bolder mb-3'>Reset Password</h1>
                    </div>

                    {/* begin::Title */}
                    {hasErrors === true && (
                        <div className='mb-lg-15 alert alert-danger'>
                            <div className='alert-text font-weight-bold'>
                                Sorry, we found an error, please try again.
                            </div>
                        </div>
                    )}

                    {hasErrors === false && (
                        <div className='alert alert-info text-center'>
                            <div>Password reset, try to log in</div>
                        </div>
                    )}

                    {showLinkLogin ?
                        (<>
                            <Link to='/auth/login'>
                                <div className='d-flex flex-row justify-content-center'>
                                    <button type='button' id='kt_login_password_reset_form_cancel_button' className='btn btn-primary'>
                                        Log In
                                    </button>
                                </div>
                            </Link>{' '}
                        </>)
                        :
                        (
                            <>
                                <div className={passwordMatch === true ? 'alert alert-success text-center' : passwordMatch === false ? 'alert alert-danger text-center' : ''}>
                                    {passwordMatch === true ? 'Confirmed Password' : passwordMatch === false ? `Passwords don't Match` : ''}
                                </div>

                                {/* PASSWORD */}
                                <div className='fv-row mb-8'>
                                    <div className='form-floating'>
                                        <input autoComplete='off' type={showFirstPassword ? 'text' : 'password'} placeholder='Password'
                                            {...formik.getFieldProps('firstPassword')}
                                            className={clsx('form-control bg-transparent',
                                                { 'is-invalid': formik.touched.firstPassword && formik.errors.firstPassword },
                                                { 'is-valid': formik.touched.firstPassword && !formik.errors.firstPassword, })}
                                        />
                                        <label htmlFor='firstPassword'>Password</label>
                                        <div className="position-absolute end-0 top-50 translate-middle-y pointer me-10" onClick={toggleFirstPasswordVisibility}>
                                            {showFirstPassword ?
                                                <KTIcon iconName='eye-slash' className=' fs-1' /> :
                                                <KTIcon iconName='eye' className=' fs-1' />}
                                        </div>
                                    </div>
                                    {formik.touched.firstPassword && formik.errors.firstPassword && (
                                        <div className='fv-plugins-message-container'>
                                            <span role='alert' className='text-danger'>{formik.errors.firstPassword}</span>
                                        </div>
                                    )}
                                </div>

                                {/* CONFIRM PASSWORD */}
                                <div className='fv-row mb-8'>
                                    <div className='form-floating'>
                                        <input autoComplete='off' type={showPassword ? 'text' : 'password'} placeholder='Confirm Password'
                                            {...formik.getFieldProps('password')}
                                            className={clsx('form-control bg-transparent',
                                                { 'is-invalid': formik.touched.password && formik.errors.password },
                                                { 'is-valid': formik.touched.password && !formik.errors.password, })} />
                                        <label htmlFor='firstPassword'>Confirm Password</label>
                                        <div className="position-absolute end-0 top-50 translate-middle-y pointer me-10" onClick={togglePasswordVisibility}>
                                            {showPassword ?
                                                <KTIcon iconName='eye-slash' className=' fs-1' /> :
                                                <KTIcon iconName='eye' className=' fs-1' />}
                                        </div>
                                    </div>
                                    {formik.touched.password && formik.errors.password && (
                                        <div className='fv-plugins-message-container'>
                                            <span role='alert' className='text-danger'>{formik.errors.password}</span>
                                        </div>
                                    )}
                                </div>

                                {/* begin::Form group */}
                                <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
                                    <button
                                        type='submit'
                                        id='kt_password_reset_submit'
                                        className='btn btn-primary me-4'
                                        disabled={formik.isSubmitting || !formik.isValid || !formik.touched}>
                                        <span className='indicator-label'>Reset</span>
                                        {loading && (
                                            <span className='indicator-progress'>
                                                Resetting...
                                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                        )}
                                    </button>
                                    <Link to='/auth/login'>
                                        <button type='button' id='kt_login_password_reset_form_cancel_button'
                                            className='btn btn-light' disabled={formik.isSubmitting || !formik.isValid} >
                                            Cancel
                                        </button>
                                    </Link>{' '}
                                </div>
                            </>
                        )
                    }

                </>
            ) : !hasValidLink ? (
                <>
                    <div className='text-center mb-5'>
                        <h1 className='fw-bolder'>Error with Request</h1>
                    </div>
                    <div className='text-gray-500 fw-semibold fs-6 px-7 mb-3'>
                        Try the recovery process again, if the problem persists, talk to the administrator.
                    </div>
                    <h1 className='text-center mb-3'>⚠️</h1>
                    <Link to='/auth/login'>
                        <div className='d-flex flex-row justify-content-center'>
                            <button type='button' id='kt_login_password_reset_form_cancel_button' className='btn btn-primary'>
                                Log In
                            </button>
                        </div>
                    </Link>{' '}
                </>
            ) : ''
            }
            {/* end::Form group */}
        </form>
    )
}
